import state from '@/store/modules/auctions/defaultState';

const actions = {
  async getMyAcvPendingProxyAuctions({
    dispatch,
  }) {
    const { persistentProxy } = this.state.featureFlags.featureFlagSlugs;
    const persistentProxyEnabled = await dispatch('getFlag', persistentProxy, { root: true });

    if (persistentProxyEnabled) {
      const auctions = await dispatch('auctions/getAuctionList', {
        apiMethod: 'getMyAcvPendingProxyAuctions',
        moduleKey: 'MyAcvActive.MyAcvActivePendingProxy',
        numberOfLoaders: 3,
        page: 1,
      }, {
        root: true,
      });
      return auctions;
    }
    return [];
  },
};

export default {
  state,
  actions,
};
